<template>
    <div class="template-progress-bar-widget">
        <vue-slider :interval="step" :min="min" :max="max" :value="value" @change="onChangeProgress" />
    </div>
</template>
<script>
import { eventBus } from "@/main";
import VueSlider from "vue-slider-component";
export default {
    name: "editor-property",
    components: {
        VueSlider
    },
    props: {
        value: {
            type: Number,
            default: 1,
        },
        max: {
            type: Number,
            default: 100
        },
        min: {
            type: Number,
            default: 0
        },
        step: {
            type: Number,
            default: 1
        },
    },
    data() {
        return {
        };
    },

    mounted() {
        let vm = this;

    },
    methods: {
        onChangeProgress(value) {
            this.$emit("input", value);
        }
    },
};
</script>
  
<style lang="scss" scoped>
$assets: "~@/assets";

.template-progress-bar-widget {
    position: relative;
    min-width: 40px;
}
</style>